import { RoleName } from '../api-client/models/RoleName';

// Маппинг ролей на русские названия
export const roleNamesRu: Record<RoleName, string> = {
  [RoleName.USER]: 'Пользователь',
  [RoleName.ADMIN]: 'Администратор',
  [RoleName.ACCOUNTANT]: 'Бухгалтер',
  [RoleName.HR]: 'HR',
  [RoleName.RECRUITER]: 'Рекрутер',
  [RoleName.LAWYER]: 'Юрист',
};

// Функция для получения русского названия роли
export const getRoleNameRu = (role: RoleName): string => {
  return roleNamesRu[role] || role;
};
